import { useMutation, useQuery } from 'react-query';
import { useUserService } from '../services/user-service';
import useCurrentUser from '../../../hooks/use-current-user';
import useToasts from '../../../hooks/use-toasts';

export const useUserWellnessHour = ({
    userId,
    onSuccess = () => {},
    onError = () => {}
}) => {
    const userService = useUserService();
    const toaster = useToasts();
    const { isAdmin } = useCurrentUser();
    const query = useQuery(
        ['user-wellness-hour', userId], 
        () => userService.getWellnessHour({ userId })
    );

    const [saveHour, { isLoading: isSaving }] = useMutation(
        (hourId) => userService.setWellnessHour({ userId, hourId }),
        {
            onSuccess: () => {
                query.refetch();
                toaster.success('Wellness hour saved');
                onSuccess();
            },
            onError: () => {
                toaster.error('Failed to save wellness hour');
                onError();
            }
        }
    );

    const {
        isLoading,
        data: hourId = '',
    } = query;

    const canSave = isAdmin;

    return {
        hourId,
        isLoading,
        saveHour,
        isSaving,
        canSave
    };
};